module.exports = __webpack_public_path__ + "media/images/badge/veggente-c4dfa3d49098bb2376df10022270a753.png";